import {CHANGE_DEV_MODE} from './available'

export default {
    [CHANGE_DEV_MODE](state, devMode) {
        state.devMode = devMode
    }
}